import React from 'react'

const Hourglass = ({
  size,
  style,
  primaryColor,
  secondaryColor,
  title = 'icon/hourglass',
  ...props
}) => (
  <svg height='20' width='20' viewBox='0 0 20 20' style={style} {...props}>
    <g
      fill='none'
      fillRule='evenodd'
      stroke='transparent'
      strokeWidth='1.0'
    >
      <path
        fill={primaryColor}
        d='M15.08 3.184c-.17 2.463-1.315 3.93-4.12 6.1 2.966 2.294 4.075 3.803 4.14 6.532h.9V17H4v-1.184h.9c.065-2.73 1.174-4.238 4.14-6.532-2.805-2.17-3.95-3.637-4.12-6.1H4V2h12v1.184h-.92zm-1.124 0H6.044C6.224 5.237 7.28 6.491 10 8.557c2.72-2.066 3.776-3.32 3.956-5.373zm.025 12.632c-.069-2.317-1.075-3.599-3.981-5.805-2.906 2.206-3.912 3.488-3.98 5.805h7.96z'
      />
    </g>
  </svg>
)

export default Hourglass
